"use client";

import React from "react";
import { MapPin, PhoneCall, Navigation } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const suburbs = ["Gorokan", "Toukley", "Norah Head", "Gwandalan", "Budgewoi", "Lake Haven", "Charmhaven", "Hamlyn Terrace", "Woongarrah", "Wadalba", "Kanwal", "San Remo", "Blue Haven", "Doyalson", "Gosford", "Wider Central Coast", "Lake Macquarie", "Newcastle"];
export default function OurServiceArea() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-service-area" className="relative bg-background py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-accent/5 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={leftRef} className={`relative transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative rounded-3xl overflow-hidden border border-border/50 shadow-xl shadow-primary/5 bg-muted/30 aspect-square sm:aspect-[4/3] group">
              {}
              <img src="https://allowing-mallard.websiteshop.au/wp-content/uploads/2026/03/pexels-matsheard-5657441-scaled.jpg" alt="Map of Northern Central Coast Service Areas" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />

              {}
              <div className="absolute bottom-6 left-6 right-6 bg-background/95 backdrop-blur-sm border border-border p-4 rounded-xl shadow-sm flex items-center gap-4">
                <div className="bg-primary/10 p-3 rounded-full text-primary shrink-0">
                  <Navigation className="size-6" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">Local Experts</p>
                  <p className="text-xs text-muted-foreground">Based in Gwandalan, serving the Coast.</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col justify-center transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent-foreground text-sm font-medium w-fit mb-6 border border-accent/20">
              <MapPin className="size-4" />
              <span>Local Service Area</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight mb-6">
              Serving Our Northern Central Coast Community
            </h2>
            
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              With over 30 years of experience, we are proud to provide top-quality residential and industrial painting services across the Northern Central Coast. We know the local climate and use the right materials to ensure a perfect, lasting finish for your property.
            </p>

            <div className="mb-10">
              <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-4">Primary Areas We Cover</h3>
              <div className="flex flex-wrap gap-2 sm:gap-3">
                {suburbs.map((suburb, i) => <Badge key={suburb} data-index={i} variant="outline" className="px-4 py-2 text-sm bg-background hover:bg-primary/5 hover:text-primary transition-colors border-border/60 shadow-2xs">
                    {suburb}
                  </Badge>)}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <Button size="lg" asChild className="w-full sm:w-auto group">
                <Link to="tel:0413771815">
                  <PhoneCall className="mr-2 size-5 transition-transform group-hover:rotate-12" />
                  Quick Call: 0413 771 815
                </Link>
              </Button>
              <p className="text-sm text-muted-foreground px-2">
                Available Monday - Saturday
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}